
import f1 from "../../assets/img/photo-zone/f-1.jpg";
import f2 from "../../assets/img/photo-zone/f-2.jpg";
import f3 from "../../assets/img/photo-zone/f-3.jpg";
import f4 from "../../assets/img/photo-zone/f-4.jpg";
import f5 from "../../assets/img/photo-zone/f-5.jpg";
import f6 from "../../assets/img/photo-zone/f-6.jpg";
import f7 from "../../assets/img/photo-zone/f-7.jpg";
import f8 from "../../assets/img/photo-zone/f-8.jpg";
import f9 from "../../assets/img/photo-zone/f-9.jpg";
import f10 from "../../assets/img/photo-zone/f-10.jpg";
import {ZoneData} from "./ZoneData";

export const SlideZone = (): ZoneData[] => [
    {
        img: f1,
        alt: "День рождения"
    },
    {
        img: f2,
        alt: "День рождения"
    },
    {
        img: f3,
        alt: "День рождения"
    },
    {
        img: f4,
        alt: "День рождения"
    },
    {
        img: f5,
        alt: "День рождения"
    },
    {
        img: f6,
        alt: "День рождения"
    },
    {
        img: f7,
        alt: "День рождения"
    },
    {
        img: f8,
        alt: "День рождения"
    },
]